import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseUrlHelperService } from '../helper/baseUrlHelper.service';
import { NbcLoggerService } from '../logger/nbc-logger.service';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {
  constructor(
    private http: HttpClient,
    private _apiroot: BaseUrlHelperService,
    private log: NbcLoggerService
  ) { }

  getTemplateListQuery(businessUnitId, currentPage, pageSize, totalRecords) {
    return {
      BUId: businessUnitId || 0,
      currentPage: currentPage || 1,
      pageSize: pageSize || 10,
      totalRecords: totalRecords || 0,
      sortByColumn: '',
      isActive: 'Y',
      reverseSort: false,
      searchOptionId: null,
      searchTerm: {
        id: null,
        description: ''
      }
    };
  }

  getPayrollTemplateDetailQuery(currentPage, pageSize, totalRecords, businessUnitId) {
    return {
      "BUId": businessUnitId || 0,
      "templateId": window.preload.templateId || 0,
      "currentPage": currentPage || 1,
      "pageSize": pageSize || 10,
      "totalRecords": totalRecords || 0,
      "sortByColumn": "",
      "reverseSort": false,
      "searchOptionId": null,
      "searchTerm": null,
    };
  }

  getPayrollTemplateQuery (currentPage?, pageSize?, totalRecords?) {
    return {
      "BUId": 0,
      "currentPage": currentPage || 1,
      "pageSize": pageSize || 10,
      "totalRecords": totalRecords || 0,
      "sortByColumn": "",
      "isActive": "Y",
      "reverseSort": false,
      "searchOptionId": null,
      "searchTerm": {
        id: null,
        description: ""
      },
    };
  }
  getTemplates(query): Observable<any> {
    this.log.trace('timesheetTemplateService: get  Timesheet template');
    return this.http
      .post(this._apiroot.baseUrl + 'get/allTemplates', query)
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  upsertTemplate(template, items): Observable<any> {
    this.log.trace('timesheetTemplateService: upsert template');
    return this.http
      .post(this._apiroot.baseUrl + 'talentPayroll/template/upsert', {
        template: template,
        timecards: items
      })
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  cloneTemplate(template): Observable<any> {
    this.log.trace('timesheetTemplateService: clone template');
    return this.http
      .post(
        this._apiroot.baseUrl + 'talentPayroll/template/cloneTemplate',
        template
      )
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }
  getAllTemplate(businessUnitId): Observable<any> {
    this.log.trace('timesheetTemplateService: get  Timesheet Tamplate');
    return this.http
      .get(this._apiroot.baseUrl + businessUnitId + '/get/templates')
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  addTemplateDetail(templateId): Observable<any> {
    this.log.trace("timesheetTemplateService: upsert timecards");
    return this.http
      .post(
        this._apiroot.baseUrl + templateId + '/talentPayroll/templateDetail/addNewTimecard','')
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

 

  saveOnTemplateChanges(template): Observable<any> {
    this.log.trace("timesheetTemplateService: upsert timecards");
    return this.http
      .post(
        this._apiroot.baseUrl + 'talentPayroll/template/saveOnTemplateChanges',
        template
      )
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  upsertTemplateDetail(templateDetail): Observable<any> {
    return this.http
      .post(
        this._apiroot.baseUrl + 'talentPayroll/templateDetail/upsert',
        templateDetail
      )
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  };

  getAllTemplateDetails(payrollTemplateDetailQuery): Observable<any> {
    this.log.trace("timesheetTemplateService: get  Timesheet Tamplate");
    return this.http
      .post(
        this._apiroot.baseUrl + 'get/allTemplateDetails',
        payrollTemplateDetailQuery
      )
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }


  getSports(): Observable<any> {
    this.log.trace("timesheetLookUpService: get Sports");
    return this.http
      .get(
        this._apiroot.baseUrl + 'talentPayroll/lookups/sports/get',

      )
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }


  getNetworks(): Observable<any> {
    return this.http
      .get(
        this._apiroot.baseUrl + 'talentPayroll/lookups/networks/get',
      )
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  getEmployeeTypes(): Observable<any> {
    this.log.trace("timesheetLookUpService: get Employee Types");
    return this.http
      .get(
        this._apiroot.baseUrl + 'talentPayroll/lookups/employeeTypes/get',
      )
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  getDayTypes(): Observable<any> {
    this.log.trace("timesheetLookUpService: get daytypes");
    return this.http
      .get(
        this._apiroot.baseUrl + 'talentPayroll/lookups/daytypes/get',
      )
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  getworkStates(): Observable<any> {
    this.log.trace("timesheetLookUpService: get WorkStates");
    return this.http
      .get(
        this._apiroot.baseUrl + 'talentPayroll/lookups/workStates/get',
      )
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }


  getCompanyCodes(): Observable<any> {
    this.log.trace("Calling get company codes");
    return this.http
      .get(
        this._apiroot.baseUrl + 'budget/companyCodes',
      )
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  assignContact(buid, timecards): Observable<any> {
    return this.http
      .post(
        this._apiroot.baseUrl +
        'talentPayroll/' +
        buid +
        '/timecards/assignContact',
        timecards
      )
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

}
